import gql from 'graphql-tag'

export const NAME = 'incrementClientGradeLevelsByOrgId'
const INCREMENT_CLIENT_GRADE_LEVELS_BY_ORG_ID = gql`
  mutation ${NAME}($orgId: ID!) {
    ${NAME}(orgId: $orgId)
  }
`
export default INCREMENT_CLIENT_GRADE_LEVELS_BY_ORG_ID
